// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__M7uuZ","loaderOuter":"PageOverlayLoader_loaderOuter__2kRTX"};